import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import {Link, NavLink} from "react-router-dom";
import ReactDOM from "react-dom";
import {CDBMain} from "./CDBMain";
import ApiService from './ApiService';
import School from '../models/School';
import { IRootState } from '../store';

interface AdminSchoolMenuProps {
    tenantId: string;
    schoolCode: string;
    apiService: ApiService;
}

interface AdminSchoolMenuState {
    school?: School;
}

class AdminSchoolMenu extends Component<AdminSchoolMenuProps, AdminSchoolMenuState> {

    static displayName = AdminSchoolMenu.name;

    constructor(props: AdminSchoolMenuProps) {
        super(props);

        this.state = {
        };
    }

    async componentDidMount() {
        await this.loadSchool();
    }

    async componentDidUpdate(prevProps: AdminSchoolMenuProps, prevState: AdminSchoolMenuState): Promise<void> {
        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode) {
            await this.loadSchool();
        }
    }

    async loadSchool() {
        if (this.props.tenantId && this.props.schoolCode) {
            let school = await this.props.apiService.getSchoolAdmin(this.props.tenantId, this.props.schoolCode);
            this.setState({ school });
        }
    }
    
    private buildNavLink(to: string,title: string,exact: boolean| undefined,disabled: boolean,disabledText: string | undefined): JSX.Element
    {
        let Component: any = NavLink;
        let props: any = {
            className: "admin-school-menu__link"
        }
        
        if(disabled)
        {
            Component = "div";
            props.className += " admin-school-menu__link--disabled";
        }
        else
        {
            props.to = to;
            props.activeClassName = "admin-school-menu__link--active";
            props.exact = exact;
        }
        
        return (
            <Component {...props}>
                <span className={"admin-school-menu__link-title"} title={disabled && disabledText ? disabledText : ""}>
                    {title}
                </span>
            </Component>
        );
    }

    private buildNavLinkBar() {
        
        let onboardNavLink: JSX.Element | null = null;
        if (this.state.school?.isOnboarding || this.state.school?.onboardStatus === "notStarted")
        {
            onboardNavLink = this.buildNavLink(`/manage/${this.props.tenantId}/${this.props.schoolCode}/onboard`, "Onboarding", true, false, undefined);
        }
        
        return (
            <div className={"admin-school-menu__link-bar"}>
                {this.buildNavLink(`/cdb-admin/schools/${this.props.tenantId}/${this.props.schoolCode}/edit`, "Edit", true, false, undefined)}
                {this.buildNavLink(`/cdb-admin/schools/${this.props.tenantId}/${this.props.schoolCode}`, "Workloads", true, false, undefined)}
                {this.buildNavLink(`/cdb-admin/mailroom/${this.props.tenantId}/${this.props.schoolCode}`, "Mailroom", undefined, this.state.school == null || this.state.school.thirdPartySDS === true, "Third Party SDS do not use Mailroom")}
                {onboardNavLink}
            </div>
        );
    }

    private buildSchoolIdentifierBar(){
        
        return (
            <div className={"admin-school-menu__school-identifier"}>
                <Link to={`/cdb-admin/tenants/${this.state.school?.tenantId}`} className={"admin-school-menu__school-identifier-tenant"} title={this.state.school?.tenantName}>
                    {this.state.school?.tenantName}
                </Link>
                <div className={"admin-school-menu__school-identifier-splitter"}>
                    /
                </div>
                <div className={"admin-school-menu__school-identifier-school"} title={this.state.school?.schoolName}>
                    {this.state.school?.schoolName}
                </div>
            </div>
        );
    }
    
    render() {
        const contentStyleOverride = process.env.REACT_APP_NAV_BACKGROUND_OVERRIDE ? { background: process.env.REACT_APP_NAV_BACKGROUND_OVERRIDE } : {};
        const menu = (
            <Fragment>
                <div className="admin-school-menu admin-school-menu--top" style={contentStyleOverride}>
                    <div className="cdb-admin-content cdb-admin-content--column">
                        {this.buildSchoolIdentifierBar()}
                    </div>
                </div>
                <div className="admin-school-menu">
                    <div className="cdb-admin-content cdb-admin-content--column">
                        {this.buildNavLinkBar()}
                    </div>
                </div>
            </Fragment>
        );

        const parent = document.querySelector(`.${CDBMain.contentHeaderClass}`);

        return ReactDOM.createPortal(menu,parent!);
    }
}

export default connect(
    (state: IRootState, ownProps: any): AdminSchoolMenuProps => {
        return {
            tenantId: ownProps.tenantId,
            schoolCode: ownProps.schoolCode,
            apiService: state.auth.apiService
        };
    }
)(AdminSchoolMenu)